/**
 * PO, 29 Sep 2026 — the length limits the API enforces (api/src/common/limits.ts),
 * applied as maxLength on the admin inputs so an admin is stopped while typing
 * instead of meeting a 400 on save. Airport name keeps its own 120 (SHAR-205).
 */
export const LIMITS = {
  name: 100,
  email: 254,
  text: 2000,
  passportNumber: 30,
  aircraftModel: 100,
  tailNumber: 20,
  // Admin regression 6 Oct — chosen with the fix, documented in
  // docs/design/input-limits.md (the PO's 29 Sep list has no number for them).
  phone: 30,
  city: 100,
  flightNumber: 20,
  airportName: 120,
} as const;

/**
 * Admin regression 6 Oct — the API's MONEY_MAX: the ceiling on every amount
 * typed (and every quote total computed). The money columns are Decimal(12,2);
 * past them the save used to die on a database overflow.
 */
export const MONEY_MAX = 999_999_999.99;

/** Admin regression 6 Oct — the API's SETTINGS_LIMITS (PO to confirm). */
export const SETTINGS_LIMITS = {
  leadTimeDays: 730,
  charterLeadTimeHours: 720,
  fixedFeeGbp: 100,
} as const;
